//https://stackoverflow.com/questions/25692514/bootstrap-how-do-i-make-dropdown-navigation-parent-links-an-active-link
// UPDATED OPINION: https://github.com/wp-bootstrap/wp-bootstrap-navwalker/issues/113 twittem commented on Dec 3, 2014
(function($, window, document) {

	let win = $(window),
			navbar,
			dropdown,
			dropdownContent;

	win.on("load", () => {

		// get the navbar
		navbar = $('nav.navbar.primary');
		if (navbar.length < 1) return;

		// get the drop down
		dropdown = navbar.find($('li.nav-item.dropdown'));
		//if (dropdown.length < 1) return;

		// do it on load
		menuInit();

		// do it on resize
		win.on('resize.menu', $.debounce(250, menuInit));

	});

	function menuInit() {

		// only do stuff on desktop
		if (win.outerWidth() >= 'NALU__BOOTSTRAP__BREAKPOINT__NALU') {

			// change position of dropdown, fix links and hover.
			fixDropdownPosition();

			// hide and unhide the menu
			positionMenu();

		}

		// make sure to turn them off
		else {
			win.off('.positionMenu');
			if (dropdown)
				dropdown.off('.fixDropdownPosition');
		}

	}

	/**
	 * hides the menu when we scroll down and shows it when we scroll up
	 */
	function positionMenu() {

		// initialse variables
		let scrolling            = false;
		let hidden               = false;
		let scroll_position_last = -1;
		let scroll_position      = 0;
		// let toc = $('.toc');
		// let hasToc = toc.length > 0;
		let speed = 200;

		// get menu and logo elements
		let navbarHeight = navbar.outerHeight();
		let logo         = navbar.find($('a.navbar-brand'));

		// this will fire at the very first of a scroll and then every quarter second durring that scroll
		win.on('scroll.positionMenu', $.throttle(250, true, () => {

			// get the curent scroll position
			scroll_position = win.scrollTop();

			// dont do anything on the first scroll fire (0s)
			if (!scrolling)
				scrolling = true;

			// if we are have been scrolling for at least .25 seconds
			else {

				// if we're scrolling down and we're past the menu height and the menu is not hidden, hide it
				if (scroll_position > scroll_position_last && scroll_position > navbarHeight && !hidden)
					hideMenu();

				// otherwise, if we're going up and the menu bar is hidden, unhide it
				else if (scroll_position < scroll_position_last && hidden)
					showMenu();

			}

			// set last postion to current
			scroll_position_last = scroll_position;

		}));

		// this gets fired after a scroll has ended
		win.on('scroll.positionMenu', $.debounce(250, () => {

			// get the curent scroll position
			scroll_position = win.scrollTop();

			// if we're at the top or bottom
			if (scroll_position < navbarHeight || scroll_position + win.height() >= ($(document).height() - navbarHeight)) {
				showMenu();
			}

			// set last postion to current
			scroll_position_last = scroll_position;

			//starting the logic over agian
			scrolling = false;

		}));

		let hideMenu = function() {
			// move menu and logo up (logo requires more)
			navbar.removeClass('show-nav')
			navbar.addClass('hide-nav')
			navbar.animate({top: "-" + navbarHeight + "px"}, speed);
			logo.animate({top: "-" + logo.outerHeight() + "px"}, speed);

			// adjust the toc to if it's there
			// if (hasToc)
			// 	toc.animate({'marginTop': 0}, speed);

			// if a dropdown was open
			if (dropdownContent && dropdownContent.length > 0) {
				dropdownContent.animate({top: "-" + dropdownContent.outerHeight() + "px"}, speed);
			}

			// mark it hidden
			hidden = true;
		};

		let showMenu = function() {
			// move them down
			navbar.removeClass('hide-nav')
			navbar.addClass('show-nav')
			navbar.animate({top: 0}, speed);
			logo.animate({top: 5}, speed);

			// adjust the toc too if it's there
			// if (hasToc && toc.hasClass('stuck'))
			// 	toc.animate({'marginTop': navbarHeight + 'px'}, speed);

			// if a dropdown is open
			if (dropdownContent && dropdownContent.length > 0) {
				dropdownContent.animate({top: navbarHeight + "px"}, speed);
			}

			// mark them un hudden
			hidden = false;
		};

	}

	/**
	 * Keeps dropdowns from extending over the eadge of screen
	 */
	function fixDropdownPosition() {

		if (dropdown)
			dropdown.on('click.fixDropdownPosition', function() {

				dropdownContent = $(this).find('ul.dropdown-menu');

				// the doc width
				let winWidth = win.width();
				let middle   = (winWidth / 2);

				// get the positions and width of the top list items
				let left  = $(this).offset().left;
				let width = $(this).outerWidth();
				let right = (left + width);

				// which side does if fall on
				let side = (middle - left) > (right - middle) ? 'left' : 'right';

				// get the positions and width of the dropdown content

				let leftContent  = left;
				let widthContent = dropdownContent.outerWidth();
				let rightContent = (left + widthContent);

				// if dropdown right edge extends past the right screen
				if (rightContent > (winWidth - 10)) {

					// if the menu item is on the right side, try swithing dropdown the other way (we have more room)
					if (side === 'right') {

						// add this BS class to make the dropdown go to the left
						dropdownContent.addClass('dropdown-menu-right');

						// get the new left position
						leftContent = (right - widthContent);

						// if the left side is now over the left edge of the screen, limit it
						if (leftContent < 10) {

							// limit the width
							dropdownContent.css({"width": (right - 10) + "px"});

							// make the dropdown items wrap
							dropdownContent.find('li a').css({"white-space": "normal"});
						}
					}

					// if the menu item is already on the left, we have to limit the dropdown width
					else {

						// limit the width
						dropdownContent.css({"width": (winWidth - left - 10) + "px"});

						// make the dropdown items wrap
						dropdownContent.find('li a').css({"white-space": "normal"});
					}
				}
				// tudu figure out how to fade in menu without preventing click handler events
			});
	}

})(jQuery, window, document);
